<ngx-charts-area-chart [results]="data" [scheme]="colorScheme" [view]="graphStyle.view" [legend]="graphStyle.legend"
    [gradient]="graphStyle.gradient" [showXAxisLabel]="graphStyle.showXAxisLabel"
    [showYAxisLabel]="graphStyle.showYAxisLabel" [xAxis]="graphStyle.xAxis" [yAxis]="graphStyle.yAxis"
    [xAxisLabel]="graphStyle.xAxisLabel" [yAxisLabel]="graphStyle.yAxisLabel"
    [legendPosition]="graphStyle.legendPosition" [legendTitle]="graphStyle.legendTitle" [curve]="curve"
    [tooltipDisabled]="false">
    <ng-template #tooltipTemplate let-model="model">
        <div class="padding-6px">
            <span class="font-size-13px">{{ model?.series }} - {{ model?.name }}</span>
            <br>
            <span class="font-size-16px">{{ model?.value }}</span>
        </div>
    </ng-template>
    <ng-template #seriesTooltipTemplate let-model="model">
        <div class="align padding-4px">
            <mat-icon [style.color]="model[0].color" class="font-size18px align-content">square</mat-icon>
            <span class="font-size-13px">Workflow: {{ model[0]?.value }}</span>
        </div>
    </ng-template>
</ngx-charts-area-chart>